<div>
  <div
    class="comparative-search-container"
    [ngClass]="{ 'comparative-search-active': isSearchMenuVisible }"
  >
    <va-icon
      size="small"
      name="sliders-horizontal"
      class="slider-icon"
    ></va-icon>
    <input
      #input
      type="text"
      nz-popover
      nzPlacement="bottomLeft"
      nzPopoverOverlayClassName="comparative-search-menu-overlay"
      nzPopoverTrigger="click"
      nzBackdrop="false"
      [(nzPopoverVisible)]="isSearchMenuVisible"
      [nzPopoverContent]="searchMenu"
      (nzPopoverVisibleChange)="handleVisibleChange($event)"
      class="comp-analysis-search-input"
      autocomplete="off"
      nzPopoverPlacement="bottomLeft"
      placeholder="Browse peer lists or comp tables"
      [formControl]="queryField"
    />
    <va-icon size="small" name="chevron-down" class="chevron-icon"></va-icon>
  </div>
</div>
<ng-template #searchMenu>
  <ng-container *ngIf="isSearchMenuVisible">
    <div *ngIf="isSearchMenuVisible">
      <app-comparative-search-menu-content
        [searchedTerm]="searchedTerm"
        [industryData]="menuData.industryMenuData"
        [compTableData]="menuData.compTableMenuData"
        [customAnalysisData]="menuData.customAnalysisMenuData"
        [watchlistData]="menuData.watchlistMenuData"
        [selectedIndustryData]="selectedIndustryData"
        [marketCapData]="marketCapData"
        [selectedMarketCapsId]="selectedMarketCapsId"
        [selectedCountriesId]="selectedCountriesId"
        [selectedRegionsId]="selectedRegionsId"
        [geographyData]="geographyData"
        [isIndustryMenuApiInProgress]="isIndustryMenuApiInProgress"
        [isCustomMenuApiInProgress]="isCustomMenuApiInProgress"
        [isCompMenuApiInProgress]="isCompMenuApiInProgress"
        [isWatchlistMenuApiInProgress]="isWatchlistMenuApiInProgress"
        [isMarketGeoApiInProgress]="isMarketGeoApiInProgress"
        [otherGeoLen]="otherGeoLen"
        [selectionInMegaMenu]="selectionInMegaMenu"
        [activatedOptions]="activatedOptions"
        [selectedSystemData]="selectedSystemData"
        [selectedWatchlistId]="selectedWatchlistId"
        [selectedCustomAnalysisId]="selectedCustomAnalysisId"
        (onIndustryApply)="handleIndustryMenuApplyButtonClick($event)"
        (onWatchlistApply)="handleWatchlistMenuApplyButtonClick($event)"
        (onCustomAnalysisApply)="handleCustomItemClick($event)"
        (onCompTabelApply)="handlSystemItemClick($event)"
        (onCancelClick)="closePopover()"
      ></app-comparative-search-menu-content>
    </div>
  </ng-container>
</ng-template>
